<template>
  <Paginate
    class="g-pagination"
    v-model="localValue"
    :page-count="pageCount"
    :container-class="'paginate'"
    v-on="$listeners"
  >
    <template v-slot:prevButton>
      <Arrow class="arrow" />
    </template>
    <template v-slot:nextButton>
      <Arrow class="arrow right" />
    </template>
  </Paginate>
</template>

<script>
import Arrow from '@/assets/icons/base/arrow.svg';
import Paginate from './pagination.vue';

export default {
  name: 'g-pagination',
  components: { Paginate, Arrow },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: Number,
    pageCount: Number,
  },
  data() {
    return {
      localValue: this.value || 1,
    };
  },
  watch: {
    localValue(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.g-pagination {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 450px;

  padding: 0;
  margin: 0 auto;
  font-size: 14px;
  letter-spacing: 0.35px;
  list-style: none;
  .arrow {
    display: block;
    width: 8px;
    height: 100%;
    line-height: 30px;
    // opacity: 0.5;
    cursor: pointer;
    &.right {
      transform: rotate(180deg);
      transform-origin: center;
    }
    .fill {
      fill: currentColor;
    }
  }

  ::v-deep {
    button {
      padding: 0%;
      padding: 5px;
      cursor: pointer;
      background: none !important;
      border: none;
      color: #898c8d;
    }
    .active {
      button {
        color: #243882;
      }
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 50px;
      // margin: 0 15px;
      &.disabled {
        button {
          opacity: 0.25;
        }
      }
      &.li-prev {
        margin-right: auto;
      }
      &.li-next {
        margin-left: auto;
      }
    }
  }
}
</style>
